import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sleep } from "./stuff";
import { listValuesToArray, getListValue, makeCustomListValue } from "./listValues";
export var simulateAsyncFetch = function simulateAsyncFetch(all) {
  var cPageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(search, offset, meta) {
      var pageSize, filtered, pages, currentOffset, currentPage, values, newOffset, hasMore;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pageSize = (meta === null || meta === void 0 ? void 0 : meta.pageSize) != undefined ? meta.pageSize : cPageSize;
            filtered = listValuesToArray(all).filter(function (_ref2) {
              var title = _ref2.title,
                value = _ref2.value;
              return search == null ? true : title.toUpperCase().indexOf(search.toUpperCase()) != -1 || "".concat(value).toUpperCase().indexOf(search.toUpperCase()) != -1;
            });
            pages = pageSize ? Math.ceil(filtered.length / pageSize) : 0;
            currentOffset = offset || 0;
            currentPage = pageSize ? Math.ceil(currentOffset / pageSize) : null;
            values = pageSize ? filtered.slice(currentOffset, currentOffset + pageSize) : filtered;
            newOffset = pageSize ? currentOffset + values.length : null;
            hasMore = pageSize ? newOffset < filtered.length : false;
            if (!delay) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return sleep(delay);
          case 11:
            return _context.abrupt("return", {
              values: values,
              hasMore: hasMore
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var mergeListValues = function mergeListValues(values, newValues) {
  var toStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hideNewValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!newValues) return values;
  var old = values || [];
  var newFiltered = newValues.filter(function (v) {
    return old.find(function (av) {
      return "" + av.value == "" + v.value;
    }) == undefined;
  }).map(function (v) {
    return hideNewValues ? _objectSpread(_objectSpread({}, v), {}, {
      isHidden: true
    }) : v;
  });
  var merged = toStart ? [].concat(_toConsumableArray(newFiltered), _toConsumableArray(old)) : [].concat(_toConsumableArray(old), _toConsumableArray(newFiltered));
  return merged;
};
export var optionToListValue = function optionToListValue(val, listValues, allowCustomValues) {
  var _val$value;
  var v = val == null || val == "" ? undefined : (_val$value = val === null || val === void 0 ? void 0 : val.value) !== null && _val$value !== void 0 ? _val$value : val;
  var item = getListValue(v, listValues);
  var customItem = allowCustomValues && !item ? makeCustomListValue(v) : undefined;
  var listValue = item || customItem;
  var lvs = listValue ? [listValue] : undefined; //not allow []
  return [v, lvs];
};
export var optionsToListValues = function optionsToListValues(vals, listValues, allowCustomValues) {
  var newSelectedListValues = vals.map(function (val, _i) {
    var _val$value2;
    var v = val == null || val == "" ? undefined : (_val$value2 = val === null || val === void 0 ? void 0 : val.value) !== null && _val$value2 !== void 0 ? _val$value2 : val;
    var item = getListValue(v, listValues);
    var customItem = allowCustomValues && !item ? makeCustomListValue(v) : undefined;
    var listValue = item || customItem;
    return listValue;
  }).filter(function (o) {
    return o != undefined;
  });
  var newSelectedValues = newSelectedListValues.map(function (o) {
    var _o$value;
    return (_o$value = o === null || o === void 0 ? void 0 : o.value) !== null && _o$value !== void 0 ? _o$value : o;
  });
  if (!newSelectedValues.length) newSelectedValues = undefined; //not allow []
  return [newSelectedValues, newSelectedListValues];
};
export var listValueToOption = function listValueToOption(lv) {
  if (lv == null) return null;
  var title = lv.title,
    value = lv.value,
    disabled = lv.disabled,
    groupTitle = lv.groupTitle,
    renderTitle = lv.renderTitle,
    children = lv.children,
    label = lv.label,
    isCustom = lv.isCustom,
    isHidden = lv.isHidden;
  var option = {
    value: value,
    title: title || label || children // fix issue #930 for AntD
  };

  if (disabled) option.disabled = disabled;
  if (groupTitle) option.groupTitle = groupTitle;
  if (renderTitle) option.renderTitle = renderTitle;
  if (isCustom) option.isCustom = isCustom;
  if (isHidden) option.isHidden = isHidden;
  return option;
};
export { getListValue };